import { FC, useContext } from 'react';
import { menuOptions } from '../../pages/CustomiseMenu/menuOptions';
import { useMenuConfig } from '../../services/menu';
import { BottomMenuBar } from '../BottomMenuBar';
import { MenuItem } from './views';
import { ShellContext } from '../Shell';

export const BottomMenu: FC = () => {
  const config = useMenuConfig();
  const {
    hideMenu: [hidden],
  } = useContext(ShellContext);

  return (
    <BottomMenuBar hidden={hidden}>
      {config.map((id) => (
        <MenuItem key={id} {...menuOptions.get(id)!} />
      ))}
    </BottomMenuBar>
  );
};
